import { useState } from 'react';
import { DEFAULT_VIDEO_CONSTRAINTS, SELECTED_VIDEO_INPUT_KEY } from '../constants';
import { useIsTrackEnabled } from '.';
import { useMediaStreamTrack } from './useMediaStreamTrack';
import { useMediaContext, useDevices } from '../MediaContext';
export const useVideoInputList = () => {
    var _a;
    const { localTracks, isAcquiringLocalTracks } = useMediaContext();
    const { videoInputDevices } = useDevices(isAcquiringLocalTracks);
    const localVideoTrack = localTracks.find((track) => track.kind === 'video');
    const mediaStreamTrack = useMediaStreamTrack(localVideoTrack);
    const [storedLocalVideoDeviceId, setStoredLocalVideoDeviceId] = useState(window.localStorage.getItem(SELECTED_VIDEO_INPUT_KEY));
    const localVideoInputDeviceId = (_a = mediaStreamTrack === null || mediaStreamTrack === void 0 ? void 0 : mediaStreamTrack.getSettings().deviceId) !== null && _a !== void 0 ? _a : storedLocalVideoDeviceId;
    const activeInput = videoInputDevices.find((device) => device.deviceId === localVideoInputDeviceId);
    const isTrackEnabled = useIsTrackEnabled(localVideoTrack);
    function onDeviceSelect(newDeviceId) {
        setStoredLocalVideoDeviceId(newDeviceId);
        window.localStorage.setItem(SELECTED_VIDEO_INPUT_KEY, newDeviceId);
        localVideoTrack === null || localVideoTrack === void 0 ? void 0 : localVideoTrack.restart(Object.assign(Object.assign({}, DEFAULT_VIDEO_CONSTRAINTS), { deviceId: { exact: newDeviceId } }));
    }
    return {
        devices: videoInputDevices.map((device) => ({
            id: device.deviceId,
            label: device.label
        })),
        onDeviceSelect,
        activeInput: {
            label: activeInput === null || activeInput === void 0 ? void 0 : activeInput.label,
            id: activeInput === null || activeInput === void 0 ? void 0 : activeInput.deviceId,
            enabled: isTrackEnabled
        }
    };
};
//# sourceMappingURL=useVideoInputList.js.map